import { render, staticRenderFns } from "./temp-lack.vue?vue&type=template&id=36920514&scoped=true"
import script from "./temp-lack.vue?vue&type=script&lang=js"
export * from "./temp-lack.vue?vue&type=script&lang=js"
import style0 from "./temp-lack.vue?vue&type=style&index=0&id=36920514&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36920514",
  null
  
)

export default component.exports